import React from 'react';

import PageLoader from '@components/PageLoader/index';

import { useSession } from '@hooks/useSession';

const PrivateRoute: React.FC<React.PropsWithChildren> = ({ children }) => {
  const {
    state: { isLoadingAuth, isAuthenticated },
  } = useSession();

  const loading = isLoadingAuth;

  if (loading || !isAuthenticated) {
    return <PageLoader />;
  }
  return <>{children}</>;
};

export default PrivateRoute;
